function stripTrailingSlash(s: string): string {
  return s.replace(/\/$/, '');
}

const fromEnv = process.env.NEXT_PUBLIC_API_URL || process.env.API_URL || '';

/**
 * Base URL of the Nest host (no trailing slash). Default `http://127.0.0.1:4000` avoids Windows
 * resolving `localhost` to `::1` while the API listens on IPv4 only (browser fetch then fails).
 * Matches `apps/api/src/main.ts` (`PORT` or 4000). Server code may use `API_URL` (no NEXT_PUBLIC_ prefix).
 */
export const API_URL = stripTrailingSlash(fromEnv || 'http://127.0.0.1:4000');

/**
 * Absolute URL to a Nest route under `/api/...`.
 * In the browser during `next dev`, always uses same-origin `/dms-dev-api/...` (rewritten by Next to
 * Nest) so client fetches work even when `NEXT_PUBLIC_API_URL` is `http://localhost:4000` and the
 * OS resolves `localhost` to `::1` while Nest listens on IPv4 only. Server-side code still uses
 * `API_URL` for direct Node → Nest requests. Set `NEXT_PUBLIC_DMS_API_NO_PROXY=1` to force direct
 * browser URLs (e.g. remote API during local web dev).
 */
export function buildNestApiUrl(apiPath: string): string {
  const p = apiPath.startsWith('/') ? apiPath : `/${apiPath}`;
  const noProxy = process.env.NEXT_PUBLIC_DMS_API_NO_PROXY === '1';
  const useDevProxy =
    typeof window !== 'undefined' &&
    process.env.NODE_ENV === 'development' &&
    !noProxy;
  if (useDevProxy) {
    return `/dms-dev-api${p}`;
  }
  return `${API_URL}/api${p}`;
}
